var Marketplace = (function($) {

  /**
   * Clears a given facet and refreshes the results
   */
  function clearFacet($facet) {
    FWP.parse_facets();
    FWP.is_reset = true;
    FWP.facets[$facet] = [];
    FWP.used_facets = {};
    FWP.refresh();
  }

  /**
   * Initializes the product image gallery slider
   */
  function productSliderInit() {
    $('#product-image-gallery').slick({
      slidesToShow: 4,
      infinite: false,
      prevArrow: '.gallery__prev',
      nextArrow: '.gallery__next',
    });
    
  }

  
  return {
    clearFacet: clearFacet,
    productSliderInit: productSliderInit
  };
  
})(jQuery);